import capitalize from 'lodash/capitalize'

import { QualityTableRow, WaterQuality } from '../api/types'
import { QualityOption } from '../constants'

export const prepareQualityRows = (data: WaterQuality[]): QualityTableRow[] | [] => {
  if (!data) return []

  const resultArr: QualityTableRow[] = []

  data.forEach((el) => {
    const suffix = capitalize(el.timeOfDay)
    const existingData = resultArr.find(
      (data) => data.shrimpAge === el.shrimpAge && data.date === el.date
    )
    
    if (existingData) {
      Object.values(QualityOption).forEach((option) => {
        ;(existingData as any)[`${option}${suffix}`] = el[option]
      })
    } else {
      const mergedObj: QualityTableRow = {
        date: '',
        salinityMorning: '',
        salinityEvening: '',
        pHMorning: '',
        pHEvening: '',
        temperatureMorning: '',
        temperatureEvening: '',
        DOMorning: '',
        DOEvening: '',
        alkaliMorning: '',
        alkaliEvening: '',
        nitriteMorning: '',
        nitriteEvening: '',
        ammoniaMorning: '',
        ammoniaEvening: '',
        terbidityMorning: '',
        terbidityEvening: '',
        shrimpAge: 0,
      }

      Object.values(QualityOption).forEach((option) => {
        ;(mergedObj as any)[`${option}${suffix}`] = el[option]
      })
      mergedObj.shrimpAge = el.shrimpAge
      mergedObj.date = el.date

      resultArr.push(mergedObj)
    }
  })
  return resultArr
}
